//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { LookupModel } from './../../common/models/LookupModel';
  
  export class AddCodeSystemModel extends ModelBase {
      static readonly $typeName = 'AddCodeSystemModel';
      public name: LookupModel;
      
  }



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/AddCodeSystemModel.ts